"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var KEY = '$___storybook.Date';
var dateType = {
  KEY: KEY,
  is: function is(value) {
    return value instanceof Date;
  },
  serialize: function serialize(value) {
    return (0, _defineProperty2.default)({}, KEY, value.toISOString());
  },
  deserialize: function deserialize(value) {
    return new Date(value[KEY]);
  }
};
var _default = dateType;
exports.default = _default;